var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{attrs:{"to":'/' + _vm.category.slug}},[_c('div',{staticClass:"name"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.category.name))])])])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a751d1f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/main-category-card.vue
// module id = UJq/
// module chunks = 0